import { Link } from 'react-router-dom';
import Breadcrumb from './BreadCrumbs';
import ScrollToTop from '../utils/scrollToTop.js';

const Section = ({ title, children }) => (
  <section className="border-b border-stone-200 py-8 last:border-0">
    <h2 className="text-2xl font-bold text-green-800">{title}</h2>
    <div className="mt-3 space-y-3 leading-7 text-gray-700">{children}</div>
  </section>
);

export default function TermsAndConditions() {
  return (
    <main>
      <ScrollToTop />
      <section className="bg-green-900 px-6 py-20 text-center text-white">
        <p className="text-sm font-semibold uppercase tracking-[0.22em] text-yellow-300">Vasundhara Seeds</p>
        <h1 className="mt-3 text-4xl font-bold">Terms &amp; Conditions</h1>
        <p className="mx-auto mt-4 max-w-2xl text-green-50">The terms that apply when you access and use our website.</p>
      </section>
      <Breadcrumb />

      <article className="mx-auto max-w-4xl px-6 py-12">
        <p className="rounded-lg bg-gray-100 px-4 py-3 text-sm text-gray-700">Last updated: September 22, 2026</p>
        <Section title="Acceptance of these terms">
          <p>By using this website, you agree to these Terms &amp; Conditions. If you do not agree, please do not use the website.</p>
        </Section>
        <Section title="Website information">
          <p>We aim to keep product and company information accurate and current. Information on this website is provided for general guidance and may change without notice. Product availability, specifications, and suitability should be confirmed with our team before making a decision.</p>
        </Section>
        <Section title="Enquiries and communications">
          <p>Submitting an enquiry does not create a purchase contract or guarantee product availability. If you choose the optional RCS communication consent on our contact form, you agree that we may use the phone number you provide to respond to your enquiry through RCS. You can withdraw this consent by contacting us.</p>
        </Section>
        <Section title="Acceptable use">
          <p>You may use this website for lawful, personal, and business-information purposes. You must not interfere with the website, attempt unauthorized access, or use its content in a way that infringes our rights or the rights of others.</p>
        </Section>
        <Section title="Intellectual property">
          <p>Unless otherwise stated, the website content, branding, images, and materials belong to Vasundhara Seeds or are used with permission. They may not be copied, reproduced, or commercially used without prior written permission.</p>
        </Section>
        <Section title="Liability and external links">
          <p>To the extent permitted by law, Vasundhara Seeds is not liable for loss arising from use of, or reliance on, this website. Links to third-party websites are provided for convenience; we do not control or endorse their content or practices.</p>
        </Section>
        <Section title="Changes and contact">
          <p>We may update these terms at any time by posting a revised version on this page. For questions, contact us at <a href="mailto:sarang@vasundharaseeds.in" className="font-semibold text-green-800 underline">sarang@vasundharaseeds.in</a> or visit our <Link to="/contact" className="font-semibold text-green-800 underline">Contact page</Link>.</p>
        </Section>
      </article>
    </main>
  );
}
